import React, { useEffect, useRef } from "react";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import "pdfjs-dist/legacy/build/pdf.worker.entry";

const PdfViewer = ({ pdfBase64 }) => {

  const containerRef = useRef(null);

  useEffect(() => {

    const renderPDF = async () => {

      if (!pdfBase64 || !containerRef.current) return;

      containerRef.current.innerHTML = "";

      const pdfData = base64ToUint8Array(pdfBase64);

      const loadingTask = pdfjsLib.getDocument({ data: pdfData });
      const pdf = await loadingTask.promise;

      const containerWidth = containerRef.current.clientWidth || window.innerWidth;

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {

        const page = await pdf.getPage(pageNum);

        const viewportBase = page.getViewport({ scale: 1 });

        // escala dinámica según ancho disponible
        const scale = Math.max(containerWidth / viewportBase.width, 1.2);

        const viewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        const pixelRatio = window.devicePixelRatio || 1;

        canvas.width = viewport.width * pixelRatio;
        canvas.height = viewport.height * pixelRatio;

        canvas.style.width = "100%";
        canvas.style.height = "auto";
        canvas.style.maxWidth = "700px"; // evita que crezca demasiado
        canvas.style.minWidth = "320px"; // evita que se comprima demasiado
        canvas.style.display = "block";
        canvas.style.marginBottom = "12px";

        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);

        containerRef.current.appendChild(canvas);

        await page.render({
          canvasContext: context,
          viewport
        }).promise;
      }
    };

    renderPDF();

    const handleResize = () => renderPDF();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);

  }, [pdfBase64]);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        maxWidth: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}
    />
  );
};

const base64ToUint8Array = (base64) => {
  const binary = atob(base64);
  const length = binary.length;
  const bytes = new Uint8Array(length);

  for (let i = 0; i < length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes;
};

export default PdfViewer;